
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  ValidationProblemDetails,
  Workorder,
  WorkordersApi,
  PerformoSettings
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    ordersApi: 'ordersApi',
    settings: 'settings'
  })
})
export default class DncOrderComponent extends Vue {
  private ordersApi!: WorkordersApi;
  private settings!: PerformoSettings;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  private popoverOpen = false;
  private validationProblems: ValidationProblemDetails = {};
  private isLoading = false;

  private get orderStatusIsCompleteSubStatus() {
    if (this.order.orderStatus && this.settings.completeSubStatuses) {
      return this.settings.completeSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private async setDNCHandler() {
    if (!this.order || !this.order.workorderId) {
      return;
    }
    const api = new WorkordersApi(this.$store.getters.getApiConfiguration);
    try {
      this.isLoading = true;
      await api.setDNC({ workorderId: this.order.workorderId });
      this.$emit('markeddnc');
      this.popoverOpen = false;
    } catch (error) {
      this.errorHandler(error);
    } finally {
      this.isLoading = false;
    }
  }

  private cancelDNC() {
    this.validationProblems = [];
    this.popoverOpen = false;
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;
    this.$emit('marked-dnc-error');
  }
}
